export default "__VITE_ASSET__DqS5nQ43__"